import { Routes, Route, Navigate } from "react-router-dom"

import Login from "../components/user/login.component";
import ActasSearch from "../components/actas/actas.search.component";

export const PublicAppRouter = () => {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ActasSearch />} />
  
        <Route path="*" element={<Navigate to="/login"/>} />
      </Routes> 
    )
  }